// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FilePreview_wrapper__8B75f {
  width: min(100vw, 300px);
  max-width: 100%;
  padding: 5px;
  border-radius: 4px;
  position: relative;
}
.FilePreview_wrapper__8B75f:hover {
  padding-right: 44px;
  background: rgba(175, 175, 178, 0.13);
  transition: 0.3s background;
}
.FilePreview_wrapper__8B75f:hover .FilePreview_delete__rn6Ly {
  opacity: 1;
  transition: 0.2s all;
}

.FilePreview_delete__rn6Ly {
  opacity: 0;
  position: absolute;
  z-index: 2;
  right: 0;
  top: 0;
  flex-shrink: 0;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 44px;
  background: transparent;
  border: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/chats/ui/FilePreview/FilePreview.module.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EAKA,kBAAA;AAHF;AAKE;EACE,mBAAA;EACA,qCAAA;EACA,2BAAA;AAHJ;AAME;EACE,UAAA;EACA,oBAAA;AAJJ;;AAQA;EACE,UAAA;EAEA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,MAAA;EAEA,cAAA;EACA,eAAA;EAEA,oBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,YAAA;EACA,WAAA;EACA,uBAAA;EAEA,SAAA;AAVF","sourcesContent":[".wrapper {\n  width: min(100vw, 300px);\n  max-width: 100%;\n  padding: 5px;\n  border-radius: 4px;\n  //display: inline-flex;\n  //align-items: center;\n  //justify-content: space-between;\n\n  position: relative;\n\n  &:hover {\n    padding-right: 44px;\n    background: rgba(175, 175, 178, 0.13);\n    transition: 0.3s background;\n  }\n\n  &:hover .delete {\n    opacity: 1;\n    transition: 0.2s all;\n  }\n}\n\n.delete {\n  opacity: 0;\n\n  position: absolute;\n  z-index: 2;\n  right: 0;\n  top: 0;\n\n  flex-shrink: 0;\n  cursor: pointer;\n\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n\n  height: 100%;\n  width: 44px;\n  background: transparent;\n\n  border: 0;\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `FilePreview_wrapper__8B75f`,
	"delete": `FilePreview_delete__rn6Ly`
};
export default ___CSS_LOADER_EXPORT___;
